import { DefaultLanguage } from '../constants'

import localStorageUtils from './localStorageUtils'
import isAppSupportedLanguage from './isAppSupportedLanguage'

class AppLanguage {
  private language: string | null

  private readonly storageKey = 'userPreferredLanguage'

  constructor() {
    const storedLanguage = localStorageUtils.getItem<string>(this.storageKey)

    if (storedLanguage != null && isAppSupportedLanguage(storedLanguage)) {
      this.language = storedLanguage
    } else {
      this.language = null

      if (storedLanguage != null) {
        localStorageUtils.removeItem(this.storageKey)
      }
    }
  }

  getUserPreferred(): string | null {
    return this.language
  }

  get(): string {
    return this.getUserPreferred() ?? DefaultLanguage
  }

  set(language: string): void {
    this.language = language
    localStorageUtils.setItem(this.storageKey, language)
  }
}

export default new AppLanguage()
